import IconLL1 from "../components/Icons/IPR/IconLL-1"
import IconLL2 from "../components/Icons/IPR/IconLL-2"
import IconLL3 from "../components/Icons/IPR/IconLL-3"
import IconLL4 from "../components/Icons/IPR/IconLL-4"
import IconLL5 from "../components/Icons/IPR/IconLL-5"
import IconLL6 from "../components/Icons/IPR/IconLL-6"
import IconLL7 from "../components/Icons/IPR/IconLL-7"
import IconLR1 from "../components/Icons/IPR/IconLR-1"
import IconLR2 from "../components/Icons/IPR/IconLR-2"
import IconLR3 from "../components/Icons/IPR/IconLR-3"
import IconLR4 from "../components/Icons/IPR/IconLR-4"
import IconLR5 from "../components/Icons/IPR/IconLR-5"
import IconLR6 from "../components/Icons/IPR/IconLR-6"
import IconLR7 from "../components/Icons/IPR/IconLR-7"
import IconUL1 from "../components/Icons/IPR/IconUL-1"
import IconUL2 from "../components/Icons/IPR/IconUL-2"
import IconUL3 from "../components/Icons/IPR/IconUL-3"
import IconUL4 from "../components/Icons/IPR/IconUL-4"
import IconUL5 from "../components/Icons/IPR/IconUL-5"
import IconUL6 from "../components/Icons/IPR/IconUL-6"
import IconUL7 from "../components/Icons/IPR/IconUL-7"
import IconUR1 from "../components/Icons/IPR/IconUR-1"
import IconUR2 from "../components/Icons/IPR/IconUR-2"
import IconUR3 from "../components/Icons/IPR/IconUR-3"
import IconUR4 from "../components/Icons/IPR/IconUR-4"
import IconUR5 from "../components/Icons/IPR/IconUR-5"
import IconUR6 from "../components/Icons/IPR/IconUR-6"
import IconUR7 from "../components/Icons/IPR/IconUR-7"
import { EIPRToothMap, IIPRToothData } from "../types"

export const iprURToothData: IIPRToothData[] = [
  {
    id: EIPRToothMap.UR_1,
    isMissingTooth: true,
    icon: <IconUR1 width={31} height={39} />,
    point: [12, 28, 20, 70, 20, 100],
    data: [],
  },
  {
    id: EIPRToothMap.UR_2,
    isMissingTooth: false,
    icon: <IconUR2 width={28} height={39} />,
    point: [12, 28, 35, 70, 35, 100],
    data: [],
  },
  {
    id: EIPRToothMap.UR_3,
    isMissingTooth: false,
    icon: <IconUR3 width={25} height={39} />,
    point: [12, 28, 55, 70, 55, 100],
    data: [],
  },
  {
    id: EIPRToothMap.UR_4,
    isMissingTooth: false,
    icon: <IconUR4 width={33} height={39} />,
    point: [12, 28, 75, 70, 75, 100],
    data: [],
  },
  {
    id: EIPRToothMap.UR_5,
    isMissingTooth: false,
    icon: <IconUR5 width={31} height={39} />,
    point: [12, 28, 95, 70, 95, 100],
    data: [],
  },
  {
    id: EIPRToothMap.UR_6,
    isMissingTooth: false,
    icon: <IconUR6 width={39} height={34} />,
    point: [12, 28, 115, 70, 115, 100],
    data: [],
  },
  {
    id: EIPRToothMap.UR_7,
    isMissingTooth: false,
    icon: <IconUR7 width={39} height={30} />,
    point: [12, 28, 125, 70, 125, 100],
    data: [],
  },
  {
    id: EIPRToothMap.UR_8,
    isMissingTooth: false,
    icon: <IconUR7 width={39} height={30} />,
    point: [12, 28, 135, 70, 135, 100],
    data: [],
  },
]

export const iprULToothData: IIPRToothData[] = [
  {
    id: EIPRToothMap.UL_1,
    isMissingTooth: false,
    icon: <IconUL1 width={31} height={39} />,
    point: [162, 28, 152, 70, 152, 100],
    data: [],
  },
  {
    id: EIPRToothMap.UL_2,
    isMissingTooth: false,
    icon: <IconUL2 width={28} height={39} />,
    point: [162, 28, 132, 70, 132, 100],
    data: [],
  },
  {
    id: EIPRToothMap.UL_3,
    isMissingTooth: false,
    icon: <IconUL3 width={25} height={39} />,
    point: [162, 28, 110, 70, 110, 100],
    data: [],
  },
  {
    id: EIPRToothMap.UL_4,
    isMissingTooth: false,
    icon: <IconUL4 width={33} height={39} />,
    point: [162, 28, 92, 70, 92, 100],
    data: [],
  },
  {
    id: EIPRToothMap.UL_5,
    isMissingTooth: false,
    icon: <IconUL5 width={31} height={39} />,
    point: [162, 28, 75, 70, 75, 100],
    data: [],
  },
  {
    id: EIPRToothMap.UL_6,
    isMissingTooth: false,
    icon: <IconUL6 width={39} height={34} />,
    point: [162, 28, 62, 70, 62, 100],
    data: [],
  },
  {
    id: EIPRToothMap.UL_7,
    isMissingTooth: false,
    icon: <IconUL7 width={39} height={30} />,
    point: [162, 28, 55, 70, 55, 100],
    data: [],
  },
  {
    id: EIPRToothMap.UL_8,
    isMissingTooth: true,
    icon: <IconUL7 width={39} height={30} />,
    point: [162, 28, 45, 70, 45, 100],
    data: [],
  },
]

export const iprLRToothData: IIPRToothData[] = [
  {
    id: EIPRToothMap.LR_1,
    isMissingTooth: false,
    icon: <IconLR1 width={25} height={44} />,
    point: [12, 180, 20, 130, 20, 90],
    data: [],
  },
  {
    id: EIPRToothMap.LR_2,
    isMissingTooth: false,
    icon: <IconLR2 width={26} height={42} />,
    point: [12, 180, 45, 130, 45, 90],
    data: [],
  },
  {
    id: EIPRToothMap.LR_3,
    isMissingTooth: false,
    icon: <IconLR3 width={33} height={50} />,
    point: [12, 180, 70, 130, 70, 90],
    data: [],
  },
  {
    id: EIPRToothMap.LR_4,
    isMissingTooth: false,
    icon: <IconLR4 width={30} height={40} />,
    point: [12, 180, 82, 130, 82, 90],
    data: [],
  },
  {
    id: EIPRToothMap.LR_5,
    isMissingTooth: false,
    icon: <IconLR5 width={23} height={33} />,
    point: [12, 180, 102, 130, 102, 90],
    data: [],
  },
  {
    id: EIPRToothMap.LR_6,
    isMissingTooth: false,
    icon: <IconLR6 width={36} height={29} />,
    point: [12, 180, 130, 130, 130, 90],
    data: [],
  },
  {
    id: EIPRToothMap.LR_7,
    isMissingTooth: false,
    icon: <IconLR7 width={39} height={30} />,
    point: [12, 180, 142, 130, 142, 90],
    data: [],
  },
  {
    id: EIPRToothMap.LR_8,
    isMissingTooth: false,
    icon: <IconLR7 width={41} height={28} />,
    point: [12, 180, 152, 130, 152, 90],
    data: [],
  },
]

export const iprLLToothData: IIPRToothData[] = [
  {
    id: EIPRToothMap.LL_1,
    isMissingTooth: false,
    icon: <IconLL1 width={25} height={44} />,
    point: [165, 180, 147, 130, 147, 90],
    data: [],
  },
  {
    id: EIPRToothMap.LL_2,
    isMissingTooth: false,
    icon: <IconLL2 width={26} height={42} />,
    point: [165, 180, 123, 130, 123, 90],
    data: [],
  },
  {
    id: EIPRToothMap.LL_3,
    isMissingTooth: false,
    icon: <IconLL3 width={33} height={50} />,
    point: [165, 180, 108, 130, 108, 90],
    data: [],
  },
  {
    id: EIPRToothMap.LL_4,
    isMissingTooth: false,
    icon: <IconLL4 width={30} height={40} />,
    point: [165, 180, 88, 130, 88, 90],
    data: [],
  },
  {
    id: EIPRToothMap.LL_5,
    isMissingTooth: false,
    icon: <IconLL5 width={23} height={33} />,
    point: [165, 180, 62, 130, 62, 90],
    data: [],
  },
  {
    id: EIPRToothMap.LL_6,
    isMissingTooth: false,
    icon: <IconLL6 width={36} height={29} />,
    point: [165, 180, 50, 130, 50, 90],
    data: [],
  },
  {
    id: EIPRToothMap.UL_7,
    isMissingTooth: false,
    icon: <IconLL7 width={39} height={32} />,
    point: [165, 180, 40, 130, 40, 90],
    data: [],
  },
  {
    id: EIPRToothMap.UL_8,
    isMissingTooth: true,
    icon: <IconLL7 width={39} height={32} />,
    point: [165, 180, 30, 130, 30, 90],
    data: [],
  },
]
